import imagesLoaded from "imagesloaded";
import { EventHandler } from "./eventHandler";
import axios from "axios";

let body = document.querySelector("body"),
    job = document.querySelector(".js-job"),
    jobContainer = document.querySelector(".js-job-container"),
    jobLoader = document.querySelector(".js-job-loader"),
    loadingIcons = document.querySelector(".js-loading-icon"),
    overlayElements = document.querySelectorAll(
        ".js-job-container, .js-breadcrumbs"
    ),
    jobIdentifier = "jobs/",
    jobIdentifierL = jobIdentifier.length,
    stateObj = {
        time: Date.now(),
    },
    winScrollT = 0,
    winW,
    winH,
    prevScrollT;

export function init() {
    if (document.querySelectorAll(".js-job-link").length) {
        ajaxJobs();
    }

    setInterval(function () {
        winScrollT = window.scrollY;
    }, 10);

    EventHandler.addEventListener(
        "resize",
        () => {
            raf(sizing);
        },
        window
    );
}

function raf(callback) {
    window.requestAnimationFrame(callback);
}

function sizing() {
    winW = window.innerWidth;
    winH = window.innerHeight;
}

function ajaxJobs() {
    // On clicking a job link
    EventHandler.addEventListener("click.job-link", (e) => {
        var $this = e.target.closest(".js-job-link");

        if (!$this) {
            return;
        }

        var slug = $this.dataset.jobSlug;

        e.preventDefault();

        // Push it
        window.history.pushState(stateObj, null, "/" + jobIdentifier + slug);

        update(slug);
    });

    // On clicking a close job link
    EventHandler.addEventListener("click.job-close", (e) => {
        var $this = e.target.closest(".js-close-job-link");

        if (!$this) {
            return;
        }

        e.preventDefault();

        // Back to the jobs page
        window.history.pushState(stateObj, null, "/" + jobIdentifier);

        // Manually parse the URL as this doesn't trigger the popstate event
        update();
    });

    // On popstate, parse it
    window.addEventListener("popstate", function (e) {
        // If this is running on page load (happens in certain browsers), don't allow it
        if (!e.originalEvent.state) {
            return;
        }

        // If the state we are returning to is from a previous page load
        if (e.originalEvent.state.time !== stateObj.time) {
            // Reload this page as the popstate change won't take us back to work
            window.location.reload();

            // Don't go on
            return;
        }

        update(getJobSlug(parseState()));
    });

    // Don't allow body scrolls on scrolling job loader
    jobLoader.addEventListener(
        "mousewheel  DOMMouseScroll  MozMousePixelScroll  touchmove",
        (e) => {
            e.preventDefault();
        }
    );
}

function setJobContents(contents) {
    // Paste the contents into the container
    job.innerHTML = contents;
}

function setJob(contents, requestTime) {
    setJobContents(contents);

    // When all the images in this job have loaded, fade it in
    imagesLoaded(job.querySelectorAll(".js-layout-image"), function () {
        // Wait until the overlay is fully showing, adding 16ms to make
        // sure this runs after the loadingIcons have been given 'reveal'.
        // This may be an issue with the accuracy of Date.now()?
        setTimeout(function () {
            // Set the flow to the job
            body.classList.add("flow-switch");

            // Scroll to the top of the job
            window.scroll({ top: 0 });

            // Hide the project loader
            jobLoader.style.height = "";
            jobLoader.classList.remove("reveal");

            // Hide the loading icon
            loadingIcons.classList.remove("reveal");

            // Show the job
            job.classList.add("reveal");
        }, Math.max(500 - (Date.now() - requestTime) + 16, 0));
    });
}

function showOverlay(overlay) {
    overlay.forEach((el) => {
        el.classList.add("reveal");
    });
}

function hideOverlay(overlay) {
    overlay.forEach((el) => {
        el.classList.remove("reveal");
    });
}

function getJob(slug) {
    var requestTime = Date.now();

    // Get the current scroll top value
    prevScrollT = winScrollT;

    // Show the loading overlay
    jobLoader.style.height = `${winH}px`;
    jobLoader.classList.add("reveal");

    // Show the overlay elements
    showOverlay(overlayElements);

    // When the overlay is fully transitioned in
    setTimeout(function () {
        // Scroll to the top of the container to the loading icon is visible
        jobContainer.scroll({ top: 0 });

        // Reveal the loading icon
        loadingIcons.classList.add("reveal");
    }, 500);

    // Request this job
    axios
        .get(`/${jobIdentifier}${slug}`, {
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
        })
        .then(function (response) {
            // Append items to list
            let returnData = response.data;

            setJob(returnData, requestTime);
        })
        .catch(function (error) {
            console.error(error);
        });
}

function closeJob() {
    var scrollT = window.scrollTop;

    // Set the flow to the body
    body.classList.remove("flow-switch");
    // Maintain the scroll position of the job container now that the
    // flow has been set back to the body to avoid a jump

    jobContainer.scroll({ top: scrollT });

    setTimeout(function () {
        // Restore the scroll position of the body
        window.scroll({ top: prevScrollT });

        // Hide the overlay
        hideOverlay(overlayElements);

        setTimeout(function () {
            // Clear the job contents so the overlay is empty next time
            setJobContents("");

            // Remove the reveal class from the job
            job.classList.remove("reveal");
        }, 500);
    }, 0);
}

function getJobSlug(path) {
    var slug = false;

    // If this path begins with the project identifier
    if (path.substring(0, jobIdentifierL) === jobIdentifier) {
        // Get everything after the project identifier
        slug = path.substring(jobIdentifierL);
    }

    return slug;
}

function update(slug) {
    // If we have a job slug, get it
    if (slug) {
        getJob(slug);
        // Otherwise, close!
    } else {
        closeJob();
    }
}
